import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/mockyeah-docs/src/layouts/default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`There are some examples included in the `}<a parentName="p" {...{
        "href": "https://github.com/mockyeah/mockyeah/tree/master/packages/mockyeah/examples"
      }}>{`mockyeah monorepo examples directory`}</a>{`.
GitHub tracks how `}<a parentName="p" {...{
        "href": "https://github.com/mockyeah/mockyeah/network/dependents?package_id=UGFja2FnZS0xNDkzNzMwNA%3D%3D"
      }}>{`users depend on the `}<code parentName="a" {...{
          "className": "language-text"
        }}>{`mockyeah`}</code>{` packages`}</a>{`.`}</p>
    <p>{`Mock suites at `}<a parentName="p" {...{
        "href": "https://github.com/mockyeah/mockyeah/tree/master/packages/mockyeah/test/mockyeah"
      }}>{`packages/mockyeah/test/mockyeah`}</a>{` connect
to fixtures at `}<a parentName="p" {...{
        "href": "https://github.com/mockyeah/mockyeah/tree/master/packages/mockyeah/test/fixtures"
      }}>{`packages/mockyeah/test/fixtures`}</a>{` in the unit tests.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      